// Port z partials.js linie 882-907 (bindSearch).

function initSearchDrawer() {
  const drawer = document.getElementById('search-drawer');
  if (!drawer) return;
  const panel = drawer.querySelector('[data-search-panel]');
  const backdrop = drawer.querySelector('[data-search-backdrop]');
  const input = drawer.querySelector('[data-search-input]');

  let closeTimer = null;
  let podkladka = null;

  // Nagłówek wyjęty z układu (`fixed`) zwolniłby swoje miejsce i cała treść podskoczyłaby
  // w górę o jego wysokość. Podkładka o tej samej wysokości trzyma układ bez zmian.
  function przypnijNaglowek() {
    const wrap = document.getElementById('site-header-wrap');
    if (!wrap || podkladka) return;
    const h = wrap.offsetHeight;
    podkladka = document.createElement('div');
    podkladka.style.height = h + 'px';
    wrap.parentNode.insertBefore(podkladka, wrap);
    wrap.style.position = 'fixed';
    wrap.style.top = '0';
    wrap.style.left = '0';
    wrap.style.right = '0';
    document.documentElement.style.setProperty('--mega-top', h + 'px');
    document.documentElement.classList.add('kb-search-open');
  }

  function odepnijNaglowek() {
    const wrap = document.getElementById('site-header-wrap');
    document.documentElement.classList.remove('kb-search-open');
    if (!wrap || !podkladka) return;
    wrap.style.position = '';
    wrap.style.top = '';
    wrap.style.left = '';
    wrap.style.right = '';
    podkladka.remove();
    podkladka = null;
    window.dispatchEvent(new Event('scroll')); // niech header.js przeliczy --mega-top
  }

  function open() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    drawer.classList.remove('pointer-events-none', 'invisible');
    drawer.setAttribute('aria-hidden', 'false');
    // Force reflow tak żeby przeglądarka miała stan PRZED transition (visibility:hidden + translateY(-100%)),
    // a dopiero po nim ustawiamy końcowe wartości — wtedy animacja gra od początku.
    void drawer.offsetWidth;
    backdrop.style.opacity = '1';
    panel.style.transform = 'translateY(0)';
    setTimeout(() => input && input.focus(), 80);
    // Strona zostaje przewijalna (to panel przy krawędzi, nie modal), ale nagłówek na czas
    // otwarcia przypinamy na sztywno. Sam `sticky` przykleja go dopiero po minięciu paska
    // ogłoszeń, więc w okolicy góry strony zmieniałby pozycję o jego wysokość — a panel,
    // zaczepiony o dół nagłówka, jechałby razem z nim. Po przypięciu oba stoją nieruchomo.
    przypnijNaglowek();
  }
  function close() {
    drawer.classList.add('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.style.opacity = '0';
    panel.style.transform = 'translateY(-100%)';
    odepnijNaglowek();

    // Po zakończeniu animacji (400ms transform + 300ms opacity) chowamy wrapper completely,
    // żeby box-shadow panelu nie wyciekał spod menu jako "biały pasek".
    closeTimer = setTimeout(() => {
      drawer.classList.add('invisible');
      closeTimer = null;
    }, 420);
  }

  document.querySelectorAll('[data-search-open]').forEach((b) => b.addEventListener('click', open));
  document.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', close));
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // „Wyszukuj w rozmiarze" — pigułki są WIELOKROTNEGO wyboru. Wybrane lądują w hidden
  // inpucie `filter_rozmiar` rozdzielone przecinkiem (format, który czyta WooCommerce),
  // a filtr łączy je przez LUB: „M, L" = wszystkie M oraz wszystkie L, nie tylko te
  // dostępne w obu rozmiarach naraz.
  const sizeInput = drawer.querySelector('[data-search-size-input]');
  const sizeBtns = drawer.querySelectorAll('[data-search-size]');
  const wybrane = new Set();

  function odswiez() {
    if (sizeInput) sizeInput.value = Array.from(wybrane).join(',');
    sizeBtns.forEach((b) => {
      const v = b.getAttribute('data-search-size') || '';
      if (v === '') {
        // „Wszystkie" = brak zawężenia; podświetlone dokładnie wtedy, gdy nic nie wybrano.
        const puste = wybrane.size === 0;
        b.classList.toggle('text-black', puste);
        b.classList.toggle('text-black/55', !puste);
        b.setAttribute('aria-pressed', puste ? 'true' : 'false');
        return;
      }
      const on = wybrane.has(v);
      b.classList.toggle('bg-black', on);
      b.classList.toggle('text-white', on);
      b.classList.toggle('border-black', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  sizeBtns.forEach((b) => b.addEventListener('click', () => {
    const v = b.getAttribute('data-search-size') || '';
    if (v === '') {
      wybrane.clear();            // „Wszystkie" czyści wybór
    } else if (wybrane.has(v)) {
      wybrane.delete(v);          // ponowny klik odznacza
    } else {
      wybrane.add(v);
    }
    odswiez();
  }));

  try {
    const cur = new URLSearchParams(window.location.search).get('filter_rozmiar') || '';
    cur.split(',').forEach((s) => {
      const v = s.trim().toLowerCase();
      if (v) wybrane.add(v);
    });
  } catch (_) { /* noop */ }
  odswiez();

  // Popular chips — zachowaj wybrane rozmiary przy nawigacji (klient zaznaczył M i L,
  // klik "Real Madryt" ma dać Real Madryt w M lub L, nie we wszystkich rozmiarach).
  drawer.querySelectorAll('[data-search-chip]').forEach((chip) => {
    chip.addEventListener('click', function (e) {
      const size = (sizeInput && sizeInput.value || '').trim();
      if (!size) return; // brak wybranego rozmiaru — natywna nawigacja
      const href = chip.getAttribute('href') || '';
      if (!href || href === '#') return;
      e.preventDefault();
      try {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('filter_rozmiar', size);
        window.location.href = url.toString();
      } catch (_) {
        // Fallback dla starych przeglądarek — prosty concat.
        const sep = href.indexOf('?') === -1 ? '?' : '&';
        window.location.href = href + sep + 'filter_rozmiar=' + encodeURIComponent(size);
      }
    });
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initSearchDrawer();
  else document.addEventListener('DOMContentLoaded', initSearchDrawer);
}
